export default function (state, value) {
    state.loading = false;
    state.items = [];
    state.admin = false;
    state.finances = false;
    state.financesPayments = false;
    state.financesStatements = false;
    state.financesRegulars = false;
    state.financesInvoices = false;
    state.financesCertificates = false;
    state.financesOsv = true;
}